import { decodeProfileValues } from '@pkgs/api';
import { Headline } from '@ev-tech/ui-core-components/Headline';

import { useListing } from '@/hooks/queries/useListing';

export const ExposeHeadline = () => {
  const {
    data: { genericListing },
  } = useListing();
  const profile = decodeProfileValues(genericListing.profile);

  if (!profile.title) return null;

  return <Headline label={profile.title} as="h1" size="h3" />;
};
